import { render, staticRenderFns } from "./NewMethodForm.vue?vue&type=template&id=05ef118a&"
import script from "./NewMethodForm.vue?vue&type=script&lang=js&"
export * from "./NewMethodForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports